"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_i18next_1 = require("react-i18next");
const use_when_changed_1 = __importDefault(require("../../utils/use-when-changed"));
const utils_1 = require("../../utils/utils");
const callout_1 = __importStar(require("../callout"));
const google_maps_context_provider_1 = require("../google-maps-context-provider");
const location_search_results_1 = __importDefault(require("../location-search-results"));
const location_auto_complete_1 = __importDefault(require("../location-auto-complete"));
const hooks_1 = require("../../utils/hooks");
require("./styles.scss");
function LocationSearchQuery({ getSearchResultComponent, locations, search, customLocations, customLocationIcon, filters, maxResults, filterItems, searchParamDefaults, hasApplicationHeader, disableFilter, searchResultsHeader, onCurrentLocationChange }) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const [isClient, setIsClient] = (0, react_1.useState)(false);
    // Forces a full re-render of this component to update open-close time classes
    // See https://reactjs.org/docs/react-dom.html#hydrate under
    // "If you intentionally need to render something different on the server and the client"
    (0, react_1.useEffect)(() => setIsClient(true), []);
    const { isLoaded } = (0, react_1.useContext)(google_maps_context_provider_1.GoogleMapsContext);
    const filteredLocs = (0, hooks_1.useSearchFilters)(locations, filters);
    const [locationError, setLocationError] = (0, react_1.useState)(false);
    const [showSearch, setShowSearch] = (0, react_1.useState)(false);
    const [location, setLocation] = (0, react_1.useState)();
    const [locationFromURL, setLocationFromURL] = (0, react_1.useState)(null);
    const [buttonLastClickedAt, setButtonLastClickedAt] = (0, react_1.useState)(null);
    const [searchParams, setSearchParams] = (0, react_1.useState)(new URLSearchParams(search));
    // The following sets SearchForm only when search (URL params string) changes:
    (0, use_when_changed_1.default)((current) => {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        setSearchParams(new URLSearchParams(current));
        const currentLocation = (0, utils_1.parseSearch)(current);
        if (isNaN(currentLocation.lat) || isNaN(currentLocation.lng)) {
            setLocationError(true);
        }
        else {
            if (isNaN((_b = (_a = currentLocation.viewport) === null || _a === void 0 ? void 0 : _a.south) !== null && _b !== void 0 ? _b : NaN) ||
                isNaN((_d = (_c = currentLocation.viewport) === null || _c === void 0 ? void 0 : _c.west) !== null && _d !== void 0 ? _d : NaN) ||
                isNaN((_f = (_e = currentLocation.viewport) === null || _e === void 0 ? void 0 : _e.north) !== null && _f !== void 0 ? _f : NaN) ||
                isNaN((_h = (_g = currentLocation.viewport) === null || _g === void 0 ? void 0 : _g.east) !== null && _h !== void 0 ? _h : NaN)) {
                currentLocation.viewport = undefined;
            }
            setLocation(currentLocation);
            setLocationFromURL(currentLocation);
        }
    }, search, "");
    (0, react_1.useEffect)(() => {
        setShowSearch(isLoaded && !!isClient && !!locationFromURL);
    }, [isLoaded, isClient, locationFromURL]);
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: showSearch && locationFromURL && ((0, jsx_runtime_1.jsx)(location_search_results_1.default, { filterItems: filterItems, getSearchResultComponent: getSearchResultComponent, locations: filteredLocs, currentLocation: locationFromURL, buttonLastClickedAt: buttonLastClickedAt, maxResults: maxResults, hasApplicationHeader: hasApplicationHeader, searchParamDefaults: searchParamDefaults, disableFilter: disableFilter, searchResultsHeader: searchResultsHeader, searchBox: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(location_auto_complete_1.default, { htmlId: "autocomplete", location: location, setLocation: (location) => {
                            if (onCurrentLocationChange && location) {
                                onCurrentLocationChange(location);
                            }
                            (0, utils_1.doSearch)(location, setButtonLastClickedAt, searchParams);
                        }, customLocations: customLocations, customLocationIcon: customLocationIcon, ariaInvalid: locationError }), locationError && ((0, jsx_runtime_1.jsx)(callout_1.default, { id: "location-error", className: "custom-padding form-error-callout", data: {
                            type: callout_1.CalloutType.Alert,
                            title: "",
                            message: t("locationErrorMessage"),
                        } }))] }) })) }));
}
exports.default = LocationSearchQuery;
